import { combineReducers } from "redux";

import * as config from "./config";
import * as displaySize from "./displaySize";
import * as editingConfigName from "./editingConfigName";
import * as formError from "./formError";
import * as isOverlay from "./isOverlay";
import * as screenName from "./screenName";
import * as widgetConfigId from "./widgetConfigId";
import * as widgetId from "./widgetId";

export const reducer = combineReducers({
  config: config.reducer,
  displaySize: displaySize.reducer,
  editingConfigName: editingConfigName.reducer,
  formError: formError.reducer,
  isOverlay: isOverlay.reducer,
  screenName: screenName.reducer,
  widgetConfigId: widgetConfigId.reducer,
  widgetId: widgetId.reducer,
});

export interface StoreState {
  config: config.StoreState;
  displaySize: displaySize.StoreState;
  editingConfigName: editingConfigName.StoreState;
  formError: formError.StoreState;
  isOverlay: isOverlay.StoreState;
  screenName: screenName.StoreState;
  widgetConfigId: widgetConfigId.StoreState;
  widgetId: widgetId.StoreState;
}
